import { useReward } from '@/contexts/reward-context';
import { ArrowLeftIcon } from './svg-icons';
import { Award, AwardType, RewardScene, WeeklyAwardsType } from '@/types';
import { EventLayout } from '@/layouts/event-layout';
import { Fragment } from 'react';
import { addCommas } from '@/utils';

export const WeeklyAwards = () => {
	const { onClose, labels, setRewardScene, onKafkaSet } = useReward();
	const back = () => {
		setRewardScene(RewardScene.Ranking);
	};
	return (
		<EventLayout scene={RewardScene.WeeklyAwards}>
			<div className="reward-ranking">
				<div className="reward-ranking__back" onClick={back}>
					<ArrowLeftIcon />
				</div>

				<div className="reward-ranking__content">
					<div className="reward-ranking__info">
						<div className="reward-ranking__title">{labels?.lbl_RPRewardsOfWeek}</div>
						<div className="reward-ranking__subtitle"></div>
						<div className="reward-ranking__text">{labels?.lbl_RPAccquireRank}</div>
					</div>

					<section className="reward-week">
						<AwardsSection section={1} />
						<AwardsSection section={2} />
						<AwardsSection section={3} />
						<AwardsSection section={4} />
						<AwardsSection section={5} />
					</section>
				</div>
			</div>
		</EventLayout >
	)
};

const AwardsSection = ({ section }: { section: number }) => {
	return (
		<section className="reward-week-card">
			<RankingSection section={section} />
			<div className="reward-week-card__row">
				<VoucherSection section={section} />
			</div>
		</section >
	)
}

const RankingSection = ({ section }: { section: number }) => {
	const { labels } = useReward();
	return (
		<div className="reward-week-card__badge">
			{
				section < 4 ? (
					<div className={`reward-badge-rank reward-badge-rank--${section}`} data-highlight="true">
						<div className="reward-badge-rank__img"></div>
					</div>
				) : (
					<span className="reward-week-card__text-rank">
						{section === 4 ? `${labels?.lbl_RPRankTop4}` : `${labels?.lbl_RPRankTop6}`}
						<br />|<br />
						{section === 4 ? `${labels?.lbl_RPRankTop5}` : `${labels?.lbl_RPRankTop10}`}
					</span>
				)
			}
		</div>
	)
}

const VoucherSection = ({ section }: { section: number }) => {
	const { labels, voucherCondition } = useReward();

	const getWeeklyAwards = () => {
		return WeeklyAwardsType[section].filter(award => {
			switch (award.AwardType) {
				case AwardType.FreeRiskBet:
					return voucherCondition.enableRiskFree;
				case AwardType.OddsBooster:
					return voucherCondition.enableOddsBooster;
				case AwardType.NicknameChange:
					return voucherCondition.enableNicknameChange;
				case AwardType.NewRiskFreeBet:
					return voucherCondition.enableNewRiskFreeBet;
				default:
					return true;
			}
		});
	};

	const getVoucherType = (voucher: Award) => {
		return {
			[AwardType.FreeRiskBet]: 'reward-icon-voucher-shield',
			[AwardType.OddsBooster]: 'reward-icon-voucher-oddsboost',
			[AwardType.SabaCoin]: 'reward-icon-voucher-exchange',
			[AwardType.NewRiskFreeBet]: 'reward-icon-voucher-shield',
		}[voucher.AwardType];
	};

	const getVoucherResource = (voucher: Award) => {
		return {
			[AwardType.FreeRiskBet]: labels?.lbl_RPRiskFreeBet,
			[AwardType.OddsBooster]: labels?.lbl_RPOddsBooster,
			[AwardType.SabaCoin]: labels?.lbl_RPSabaCoins,
			[AwardType.NewRiskFreeBet]: labels?.lbl_RPRiskFreeBet,
		}[voucher.AwardType];
	};

	return (
		getWeeklyAwards().map((item, index) => {
			return (
				<Fragment key={`${section}_${item.AwardType}_${index}`}>
					<div className="reward-week-voucher">
						<div className="reward-week-voucher__icon">
							<i className={getVoucherType(item)}></i>
						</div>
						<div className="reward-week-voucher__text">
							<span className="reward-week-voucher__name">{getVoucherResource(item)}</span>
							{
								item.AwardType === AwardType.SabaCoin ? (
									<div className="reward-week-voucher__point">
										<span className="reward-week-voucher__point-icon">
											<i className="reward-iconcolor-shop-coin"></i>
										</span>
										{addCommas(item.Amount)}
									</div>
								) : (
									<span className="reward-week-voucher__amount">X{item.Amount}</span>
								)
							}
						</div>
					</div>
				</Fragment>
			);
		})
	)
}